import { render } from "./KpiCategoriesSave.vue?vue&type=template&id=a2095240&scoped=true"
import script from "./KpiCategoriesSave.vue?vue&type=script&lang=js"
export * from "./KpiCategoriesSave.vue?vue&type=script&lang=js"

import "./KpiCategoriesSave.vue?vue&type=style&index=0&id=a2095240&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2095240"]])

export default __exports__